import { TAccountRightsFeatureList } from '@app/services/account-rights-service/response-interfaces/account-rights';

export const FEATURE_SYSTEM_CONFIGURATION: TAccountRightsFeatureList =
  'VolumeDriverSystemConfiguration';
